module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-twitter"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [(_vm.item.metaData && _vm.item.metaData.image) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.image,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _vm._v(_vm._s(_vm.item.summary) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a56a9e74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=c83xexaxmy8!./~/string-replace-webpack-plugin/loader.js?id=ibhqa3cdn7!./src/components/search/searchItemTwitter.vue
// module id = 515
// module chunks = 1